import { useLocation, useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import { ProdutosContext } from '../../../shared/contexts/ProdutosContext';
import { EstabelecimentosContext } from '../../../shared/contexts/EstabelecimentosContext';
import CardProdutoDestaque from '../components/cardProdutoDestaque';
import HeaderPagesMobile from '../../../shared/components/HeaderPagesMobile';
import FooterOpcoes from '../components/FooterOpcoes';
import styles from './VerMais.module.css'
import { FaFire, FaTags, FaStore, FaPercentage } from 'react-icons/fa';

function VerMais() {
  const location = useLocation();
  const navigate = useNavigate();
  const { section } = location.state;

  const { produtos } = useContext(ProdutosContext);
  const { estabelecimentos } = useContext(EstabelecimentosContext);

  // Garante que produtos e estabelecimentos sejam arrays
  // (produtos desativados pelo admin não devem aparecer para o cliente)
  const produtosArray = (Array.isArray(produtos) ? produtos : [])
    .filter((p) => p.disponivel?.toLowerCase() === "sim");
  const estabelecimentosArray = Array.isArray(estabelecimentos) ? estabelecimentos : [];

  // Define o ícone e título baseado na seção
  const getSectionConfig = () => {
    switch(section) {
      case 'destaques':
        return { icon: <FaFire />, title: 'Destaques' };
      case 'promocoes':
        return { icon: <FaTags />, title: 'Promoções' };
      case 'lojas':
        return { icon: <FaStore />, title: 'Estabelecimentos' };
      default:
        return { icon: <FaTags />, title: section };
    }
  };

  const config = getSectionConfig();

  return (
    <div className={styles.container}>
      <HeaderPagesMobile
        icon={config.icon}
        namePage={config.title}
      />

      <div className={styles.contentWrapper}>
        {section === 'destaques' && (
          <div className={styles.gridDestaques}>
            {produtosArray.filter(p => p.destaque === 'sim').length > 0 ? (
              produtosArray.filter(p => p.destaque === 'sim').map(produto => (
                <CardProdutoDestaque
                  key={produto.id_item}
                  id_item={produto.id_item}
                  src={produto.imagem}
                  label_title={produto.nome_item}
                  p_preco={produto.preco}
                  p_descricao={produto.descricao}
                />
              ))
            ) : (
              <div className={styles.emptyState}>
                <FaFire className={styles.emptyIcon} />
                <p className={styles.emptyMessage}>Nenhum destaque disponível no momento</p>
              </div>
            )}
          </div>
        )}

        {section === 'promocoes' && (
          <div className={styles.gridPromocoes}>
            {produtosArray.filter(p => p.promocao === 'sim').length > 0 ? (
              produtosArray.filter(p => p.promocao === 'sim').map((produto, index) => {
                const cores = [
                  'linear-gradient(135deg, #FF6B6B 0%, #FF8E53 100%)',
                  'linear-gradient(135deg, #4FACFE 0%, #00F2FE 100%)',
                  'linear-gradient(135deg, #43E97B 0%, #38F9D7 100%)',
                  'linear-gradient(135deg, #FA709A 0%, #FEE140 100%)',
                  'linear-gradient(135deg, #A8EDEA 0%, #FED6E3 100%)',
                  'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                ];

                // Encontra o estabelecimento do produto
                const estabelecimento = estabelecimentosArray.find(
                  est => est.id_estabelecimento === produto.id_estabelecimento
                );

                return (
                  <div
                    key={produto.id_item}
                    className={styles.promocaoCard}
                    style={{background: cores[index % cores.length]}}
                    onClick={() => navigate(`/pedidoclique/${produto.id_item}`, {
                      state: {
                        id_item: produto.id_item,
                        id_estabelecimento: produto.id_estabelecimento,
                        src: produto.imagem,
                        label_title: produto.nome_item,
                        p_preco: produto.preco,
                        p_descricao: produto.descricao
                      }
                    })}
                  >
                    <div className={styles.promocaoContent}>
                      <div className={styles.promocaoInfo}>
                        {estabelecimento && (
                          <span className={styles.estabelecimentoNome}>
                            {estabelecimento.nomeEstabelecimento}
                          </span>
                        )}
                        <h3 className={styles.promocaoNome}>{produto.nome_item}</h3>
                        <p className={styles.promocaoDescricao}>{produto.descricao}</p>
                        <span className={styles.preco}>R$ {parseFloat(produto.preco).toFixed(2)}</span>
                      </div>
                      {produto.imagem && (
                        <div className={styles.promocaoImageWrapper}>
                          <img
                            src={produto.imagem}
                            alt={produto.nome_item}
                            className={styles.promocaoImg}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                );
              })
            ) : (
              <div className={styles.emptyState}>
                <FaTags className={styles.emptyIcon} />
                <p className={styles.emptyMessage}>Nenhuma promoção disponível no momento</p>
                <p className={styles.emptySubtext}>Volte em breve para conferir nossas ofertas!</p>
              </div>
            )}
          </div>
        )}

        {section === 'lojas' && (
          <div className={styles.gridLojas}>
            {estabelecimentosArray.length > 0 ? (
              estabelecimentosArray.map(loja => (
                <div
                  key={loja.id_estabelecimento}
                  className={styles.lojaCard}
                  onClick={() => navigate(`/estabelecimento/${loja.id_estabelecimento}`)}
                >
                  <div className={styles.lojaImageWrapper}>
                    <img src={loja.logo} alt={loja.nomeEstabelecimento} />
                  </div>
                  <div className={styles.lojaInfo}>
                    <h3 className={styles.lojaNome}>{loja.nomeEstabelecimento}</h3>
                  </div>
                </div>
              ))
            ) : (
              <div className={styles.emptyState}>
                <FaStore className={styles.emptyIcon} />
                <p className={styles.emptyMessage}>Nenhum estabelecimento disponível</p>
              </div>
            )}
          </div>
        )}
      </div>

      <FooterOpcoes typeView="cliente"/>
    </div>
  );
}

export default VerMais;
